import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

import OrganisationViewLayer from "./OrganisationViewLayer";

const OrganisationViewPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="View Organisation Detail" />

        {/* TabsLayer */}
        <OrganisationViewLayer />

      </MasterLayout>

    </>
  );
};

export default OrganisationViewPage; 